import React from "react";
import Chart from "react-apexcharts";
import ClipLoader from "react-spinners/ClipLoader";
import { postQuery } from "../../API/DashBoard";
import { toast } from "react-toastify";

class CompanyProductChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      UpcList: [],
      wholesalerArray: [],
      loader: true,
      graphData: [],
      retailerarr: [],
      retailerGroups: [],
      series: [
        { name: "PRODUCT A", data: [] },
        { name: "PRODUCT B", data: [] },
        { name: "PRODUCT C", data: [] },
        { name: "PRODUCT D", data: [] }
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: { show: true },
          zoom: { enabled: true }
        },
        dataLabels: {
          enabled: true,
          position: "center",
          offsetY: 0,
          style: { colors: ["#fff"] },
          formatter: function (val) {
            if (typeof val === "number") return Math.round(val);
            return val;
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: { position: "bottom", offsetX: -10, offsetY: 0 }
            }
          }
        ],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 0,
            dataLabels: { position: "center" }
          }
        },
        xaxis: { type: "", categories: [] },
        legend: { position: "right", offsetY: 40 },
        fill: { opacity: 1 }
      },
      apiRawMessage: null
    };
  }

  async componentDidMount() {
    this.setState(
      {
        wholesalerArray: this.props.wholesalerArray,
        UpcList: this.props.UpcList,
        retailerarr: this.props.retailerarr
      },
      () => { this.getProductChart(); }
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.graphType !== this.props.graphType ||
      prevProps.wholesalerArray !== this.props.wholesalerArray ||
      prevProps.UpcList !== this.props.UpcList ||
      prevProps.retailerarr !== this.props.retailerarr ||
      prevProps.retailerGroups !== this.props.retailerGroups
    ) {
      this.setState({
        wholesalerArray: this.props.wholesalerArray,
        UpcList: this.props.UpcList,
        retailerarr: this.props.retailerarr
      }, () => { this.getProductChart(); });
    } else if (prevProps.productMovementType !== this.props.productMovementType) {
      this.rebindChartWithCachedData();
    }
  }

  rebindChartWithCachedData() {
    const res = { Message: this.state.apiRawMessage };
    if (!res.Message) return;
    let graphData = [];
    if (this.props.productMovementType === "1") graphData = res.Message.series;
    else if (this.props.productMovementType === "2") graphData = res.Message.qtyseries;
    else if (this.props.productMovementType === "3") graphData = res.Message.shpseries;

    const Stores = [];
    const WholeSalerName = [];
    const Message1 = [];
    const State1 = [];
    for (const obj of graphData) {
      const roundedData = Array.isArray(obj.data)
        ? obj.data.map(v => typeof v === "number" ? Math.round(v) : v)
        : obj.data;
      Stores.push(roundedData);
      WholeSalerName.push(obj.Wholesaler);
    }
    if (res.Message.xaxis && res.Message.xaxis.categories) {
      for (let j = 0; j < res.Message.xaxis.categories.length; j++) {
        State1.push(res.Message.xaxis.categories[j]);
      }
    }
    for (let i = 0; i < WholeSalerName.length; i++) {
      Message1.push({ data: Stores[i], name: WholeSalerName[i] });
    }

    const newOptions = JSON.parse(JSON.stringify({
      ...this.state.options,
      xaxis: { ...this.state.options.xaxis, type: "category", categories: State1 }
    }));

    this.setState(prevState => ({
      graphData: graphData,
      series: Message1,
      options: newOptions,
      chartKey: (prevState.chartKey || 0) + 1
    }));
  }

  async getProductChart() {
    const Stores = [];
    const WholeSalerName = [];
    const Message1 = [];
    const State1 = [];
    let data = {};
    let today = new Date().toISOString().split("T")[0];
    let dateParts = today.split("-");
    dateParts[0] = parseInt(dateParts[0], 10) - 1;
    let pastYear = dateParts.join("-");

    if (this.state.wholesalerArray.length > 0) {
      data = { type: "PMByWS", wholesaler: this.state.wholesalerArray };
    } else {
      data = { type: "PMByR", wholesaler: [] };
    }

    if (this.props.graphType === "2") {
      data.type = "PMByRG";
      data.retailerGroups = Array.isArray(this.props.retailerGroups)
        ? this.props.retailerGroups.map(group => {
          if (group && group.group_name && Array.isArray(group.wholesalers)) {
            const rsaIdentifiers = group.wholesalers
              .flatMap(wholesaler => Array.isArray(wholesaler.retailers)
                ? wholesaler.retailers.map(retailer => {
                  const val = retailer.rsa_identifier;
                  return val !== undefined && val !== null && !isNaN(val) ? parseInt(val, 10) : null;
                })
                : [])
              .filter(Number.isInteger);
            if (rsaIdentifiers.length > 0) return { [group.group_name]: rsaIdentifiers };
          }
          return null;
        }).filter(Boolean)
        : [];
    }

    try {
      const res = await postQuery({
        wholesalerArray: data.wholesaler,
        UpcList: this.state.UpcList,
        retailerarr: this.state.retailerarr,
        endDate: today,
        startDate: pastYear,
        type: data.type,
        orderBy: "calMonthYear",
        retailerGroups: data.retailerGroups
      });

      this.setState({ apiRawMessage: res.Message, loader: false }, () => {
        this.rebindChartWithCachedData();
      });
    } catch (error) {
      this.setState({ loader: false });
      toast.error(
        error?.message || "Failed to fetch product chart data. Please try again.",
        { position: "top-right", autoClose: 5000 }
      );
    }
  }

  render() {
    return (
      <>
        <div className="ProductChart" style={{ minHeight: "400px", position: "relative" }}>
          {this.state.loader ? (
            <div className="Clip_Loader">
              <ClipLoader color={"rgb(0, 143, 251)"} loading={true} size={50} />
            </div>
          ) : Array.isArray(this.state.graphData) && this.state.graphData.length > 0 ? (
            <Chart
              key={this.state.chartKey || 0}
              options={this.state.options}
              series={this.state.series}
              type="bar"
              height="400"
            />
          ) : (
            <span className="Clip_Loader">No Data Present</span>
          )}
        </div>
      </>
    );
  }
}

export default CompanyProductChart;
